import React from 'react';
import { ProviderAPI } from '../../../api';
import PropTypes from 'prop-types';
import FlowContainer from '../components/FlowContainer';
import RequestFlow from '../components/RequestFlow';

const RequestService = ({match}) => {
  const variant = match.params.itemType;
  const uuidOrSlug = match.params.slug;
  const [data, setData] = React.useState(null);

  const refreshData = async () => {
    const fetchMethod = variant === 'provider' ? ProviderAPI.getProfile : ProviderAPI.getListing;
    try {
      const { payload } = await fetchMethod(uuidOrSlug);
      setData(payload);
    } catch (err) {
      console.log(err) // eslint-disable-line
    }
  };

  React.useEffect(() => {
    refreshData();
  }, [uuidOrSlug]); // eslint-disable-line

  if (data === null) {
    return null;
  }

  const providerUuid = variant === 'provider' ? data.uuid : data.provider_uuid;
  const providerName = variant === 'provider' ? data.name : data.provider_name;
  const listingUuid = variant === 'provider' ? null : data.uuid;
  const listingTitle = variant === 'provider' ? null : data.title;
  const service = variant === 'provider' ? null : data.service;
  const services = variant === 'provider' ? data.services : null;
  const slug = data.slug;

  return (
    <FlowContainer>
      <RequestFlow
        variant={variant}
        slug={slug}
        providerUuid={providerUuid}
        providerName={providerName}
        listingUuid={listingUuid}
        listingTitle={listingTitle}
        service={service}
        services={services}
      />
    </FlowContainer>
  );

};

RequestService.propTypes = {
  match: PropTypes.object.isRequired,
};

export default RequestService;
